// fake datauri module to import in browser context
// to be able to keep a common graphGenerationUtils module for both node and angular
const name = 'noop_datauri_module'
export default name
